<script>
  import { doLoading } from "../../Api/congress_stores.js";
  import { Button } from "../../../Components";
  import { Clock, Loading } from "../../../Components/Icons";

  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  export let item;
  export let anmeldestop;
  export let eventlistData;

  let notRegistred = eventlistData.tnHasKongress != 1 ? "Sie sind nicht für diesen Kongress angemeldet." : false;

  let showLoading = false;

  doLoading.subscribe((value) => {
    showLoading = value;
  });

  function processBookingAction(actionType) {
    doLoading.update(() => true);

    // Check if the user is registered for the congress
    if (actionType.startsWith("booking") && notRegistred) {
      alert(notRegistred);
      doLoading.update(() => false);
      return;
    }

    dispatch("booking", { actionType, actionId: item.veranstaltungId });
  }

  let button = {
    info: null,
    text: null,
    action: null,
  };

  function setupButton() {
    notRegistred = eventlistData.tnHasKongress != 1 ? "Sie sind nicht für diesen Kongress angemeldet." : false;

    if (eventlistData.tnHasSeat == 1) {
      button = {
        info: '<strong class="text-green-700">Ein Sitzplatz ist für Sie reserviert.</strong>',
        text: "Abmelden",
        action: "unbooking",
      };
      return;
    }

    if (eventlistData.tnIsModerator == 1) {
      button = {
        info: '<strong class="text-green-700">Sie sind Moderator: Ein Sitzplatz ist für Sie reserviert.</strong>',
      };
      return;
    }

    if (eventlistData.tnTimeBlocked == 1) {
      button = {
        info: '<strong class="text-red-700">Sie sind schon zu einer anderen Veranstaltung zum selben Zeitpunkt angemeldet!</strong>',
      };
      return;
    }

    if (eventlistData.tnSeatAvailable == 1) {
      button = {
        text: "Sitzplatz reservieren",
        action: "booking",
      };
      return;
    }

    if (eventlistData.tnHasWaitinglist == 1) {
      button = {
        info: "Sie sind aktuell auf der Warteliste. Sollte ein reservierter Sitzplatz frei werden, werden Sie umgehend via Mail darüber informiert.",
        text: "Warteliste abmelden",
        action: "unbookingWaitinglist",
      };
      return;
    }

    button = {
      info: "Das Kontingent der Onlinesitzplatzbuchung ist bereits erschöpft. Nutzen Sie bitte die Möglichkeit der Warteliste.",
      text: "Warteliste",
      action: "bookingWaitinglist",
    };

    if (item.typ == 2) {
      button["info"] = "Dieses Gruppengespräch ist bereits ausgebucht. Bitte nutzen Sie die Möglichkeit der Warteliste" + (item.referent1O2oVeranstaltungId > 0 ? " oder eines One-to-One" : "") + ".";
    }

    button["info"] += " Sollte ein reservierter Sitzplatz frei werden, werden Sie umgehend via Mail darüber informiert.";
  }

  $: setupButton(item, eventlistData);
</script>

<div class="flex justify-between">
  {#if item.startDate != ""}
    <span class="flex items-center gap-2">
      <Clock class="h-4 w-4" />
      {item.startDate}, {item.startTime} - {item.endTime}{#if item.location != ""}, {#if item.typ == 2}Raum{:else}Saal{/if}
        {item.location}{/if}
    </span>
  {/if}

  <a href="/kongress/mein-account#myEvents|overview" class="text-theme-signal"
    ><svg class="svg-inline--fa fa-xl" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
      ><path
        d="M64 64C46.3 64 32 78.3 32 96v64H480V96c0-17.7-14.3-32-32-32H64zM32 192V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192H32zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 256H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zM352.2 90.3L384 109.3l31.8-19.1c7.6-4.5 17.4-2.1 21.9 5.5s2.1 17.4-5.5 22l-40 24c-5.1 3-11.4 3-16.5 0l-40-24c-7.6-4.5-10-14.4-5.5-22s14.4-10 21.9-5.5z"
      ></path></svg
    ></a
  >
</div>

{#if !anmeldestop && !showLoading}
  {#if button.info}<p class="my-2">{@html button.info}</p>{/if}
  {#if button.action && button.text}
    <Button
      minor
      class="my-2"
      on:click={() => {
        if (notRegistred) {
          return;
        }
        processBookingAction(button.action);
      }}
      tooltip={notRegistred}
      disabled={notRegistred || showLoading}
    >
      {button.text}
      <Loading {showLoading} />
    </Button>
  {/if}
  {#if item.referent1O2oVeranstaltungId}
    <p class="mt-4">Sie können auch die Möglichkeit eines One to One mit {item.referent1name} nutzen.</p>
    <Button
      minor
      class="mt-2"
      on:click={() => {
        const showVeranstaltungId = item.referent1O2oVeranstaltungId;
        dispatch("showVeranstaltung", {
          showVeranstaltungId,
        });
      }}
      disabled={showLoading}
      tooltip={notRegistred}
    >
      One-to-One
      <Loading {showLoading} />
    </Button>
  {/if}
  {#if item.typ == 1 && item.referent2O2oVeranstaltungId}
    <p class="mt-4">Sie können auch die Möglichkeit eines One to One mit {item.referent2name} nutzen.</p>
    <Button
      minor
      class="mt-2"
      on:click={() => {
        doLoading.update(() => true);
        const showVeranstaltungId = item.referent2O2oVeranstaltungId;
        dispatch("showVeranstaltung", {
          showVeranstaltungId,
        });
      }}
      disabled={showLoading}
      tooltip={notRegistred}
    >
      One-to-One
      <Loading {showLoading} />
    </Button>
  {/if}
{:else if showLoading}
  <Loading />
{/if}
